export enum OrganisationMapSupplementaryData {
    TeamMembers,
    Accountabilities,
    Roles,
    Systems,
}
